export default __webpack_public_path__ + "static/media/searchIcon.ea6410cb.svg";